// redirect-if-authenticated.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Principal } from '../../shared/auth/principal.service';

@Injectable()
export class RedirectIfAuthenticatedGuard implements CanActivate {
  constructor(private principal: Principal, private router: Router) {}

  canActivate(): Promise<boolean> | boolean {
    return this.principal.identity().then(user => {
      if (user) {
        this.router.navigate(['/lesson']);
        return false;
      }
      return true;
    });
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/auth/redirect-if-authenticated.guard.ts